import { Outlet } from 'react-router-dom';

export const BuildingRegistrationExternalOutlet = () => <Outlet />;
